// @ts-nocheck
import { Course, Me, Team } from '@yandex-int/k-common/typings';
import { isTestplane } from '@yandex-int/k-common/utils/client/is-testplane';
import b from 'b_';
import isEmpty from 'lodash/isEmpty';
import { Button, SimpleCallback, Text } from 'platform-components';
import { Redirect, Route, Switch } from 'platform-components/src/components/router/router';
import { getMe } from 'platform-components/src/components/user/selectors';
import { withLocalStorage, WithLocalStorageProps } from 'platform-components/src/utils/hocs/withLocalStorage';
import {
    InjectedProps as WithRouterPathHOC,
    mediaQueryResolver,
    SCREEN_SIZE,
    WithMediaQueryResolverProps,
    withRouterPath,
} from 'platform-components/hocs';
import { mePropType, sendLessonYaMetrika } from 'platform-components/utils';
import PropTypes from 'prop-types';
import qs from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { AfishaBannerContainer } from 'common.components/afisha-banner/afisha-banner.container';
import { BetaBanner } from 'common.components/beta-banner/beta-banner';
import * as classActions from 'common.components/classes/actions';
import * as classesSelectors from 'common.components/classes/selectors';
import ClosingLessonModal from 'common.components/closing-lesson-modal/closing-lesson-modal';
import CopyLessonModal from 'common.components/copy-lesson-modal/copy-lesson-modal';
import { CustomLessonInfoModal } from 'common.components/custom-lesson-info-modal/custom-lesson-info-modal';
import { actions as lessonActions } from 'common.components/lesson';
import { LessonViewWithAddSchoolControl as LessonView } from 'common.components/lesson-view.index/lesson-view_with-add-school-control';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import { SubscriptionModal } from 'common.components/lesson-view.subscription-modal/subscription-modal';
import SubjectsNav from 'common.components/subjects-nav/subjects-nav';
import {
    getAssignedLessonsCount,
    getCurrentClass,
    getCurrentTeamLevel,
    getIsInBaseCertificateExperiment,
} from 'common.components/user/selectors';
import * as courseStatsActions from 'store/course-stats/actions';
import { actions as coursesActions } from 'store/courses/actions';
import * as courseSelectors from 'store/courses/selectors';
import { CourseLessonCounts, LessonsCount } from 'store/courses/typings';
import { diagnosticsActions } from 'store/diagnostics/actions';
import * as diagnosticsSelectors from 'store/diagnostics/selectors';
import { getCurrentYearOrSearchStringCourseId } from 'utils/get-course';

import { getIsTeacherFromMes } from 'utils/external-lms/external-lms';
import { CourseContainerLastLessonWidget } from 'common.components/widgets.course-container-last-lesson/course-container-last-lesson-widget';
import BREAKPOINTS from '../../../../design/breakpoints.scss';
import { ReduxTeacherStore, RootAction } from '../../typings';
import { CourseCalendar } from '../course-calendar/course-calendar';
import { getCurrentWeek, getPeriodSearchString } from '../course-calendar/utils';
import EmptyState from '../empty-state/empty-state';
import { CourseContainerProps, withCourseContainer } from '../library.course-container/with-course-container';
import { OverviewBanner } from '../overview-banner/overview-banner';
import { getCanCreateNormalLessonFromBanner } from '../overview-banner/selectors';
import { TeacherCertificateModal } from '../teacher-certificate-modal/teacher-certificate-modal';

import ActiveLessonsTab from './__active-tab/course-view__active-tab';
import AddLessonButton from './__add-lesson-button/course-view__add-lesson-button';
import { CourseViewCertificateBanner } from './__certificate-banner/course-view__certificate-banner';
import CompletedLessons from './__completed-lessons/course-view__completed-lessons';
import { CourseViewDisplayModeButton } from './__display-mode-button/course-view__display-mode-button';
import Drafts from './__drafts/course-view__drafts';
import Header from './__header/course-view__header';
import { CourseViewLessonsTabs } from './__lessons-tabs/course-view__lessons-tabs';
import * as actions from './actions';
import {
    getShouldShowContent,
    getShouldShowEmptyState,
    getIsLessonsCountLoading,
    getShouldShowSkillStats,
} from './selectors';
import { COURSE_VIEW_DISPLAY_MODE, COURSE_VIEW_LESSONS_TABS } from './typings';
import { getFormattedLessonsCount } from './utils';

import './course-view.scss';

export enum SCREEN_QUERY {
    SMALL = '(max-width: 599px)',
    MEDIUM = '(min-width: 600px) and (max-width: 1279px)',
    LARGE = '(min-width: 1280px)',
}

interface StateProps {
    grade: number | null;
    shouldLoadDiagnostic: boolean;
    allLessonsCounts: Record<number, CourseLessonCounts | undefined>;
    teamId: number;
    course: Course;
    isClosed: boolean;
    courseId: number | null;
    courses: Array<Course>;
    currentClass: Team | null;
    lessonsCounts: LessonsCount;
    me: Me | null;
    assignedLessonsCount: number;
    shouldShowContent: boolean;
    shouldShowEmptyState: boolean;
    isLessonsCountLoading: boolean;
    shouldShowSkillStats: boolean;
    isInBaseCertificateExperiment: boolean;
    canCreateNormalLessonFromBanner: boolean;
    isTeamUnset: boolean;
}

interface DispatchProps {
    getClessonWithResultsRequest: typeof lessonActions.getClessonWithResultsRequest;
    getLessonsCountRequest: typeof coursesActions.getLessonsCountRequest;
    getDiagnosticRequest: typeof diagnosticsActions.getDiagnosticRequest;
    toggleLessonModal: (shouldShow: boolean) => void;
    closeLessonModal: SimpleCallback;
    getCourseStatsRequest: typeof courseStatsActions.getCourseStatsRequest;
    getTeam: typeof classActions.getTeam;
}

interface HOCProps
    extends CourseContainerProps,
        WithLocalStorageProps,
        WithRouterPathHOC,
        WithMediaQueryResolverProps {}

type CourseViewProps = StateProps & DispatchProps & HOCProps;

// eslint-disable-next-line @typescript-eslint/ban-types
export class CourseView extends React.Component<CourseViewProps, {}> {
    static contextTypes = {
        data: PropTypes.shape({
            getMe: mePropType,
        }),
        staticUrls: PropTypes.shape({
            labSubjectLessonsComplete: PropTypes.string.isRequired,
        }),
        initialRender: PropTypes.bool,
    };

    componentDidMount() {
        const {
            courseId,
            getClessonWithResultsRequest,
            getCourseStatsRequest,
            history,
            location,
            match: { params },
            me,
            toggleLessonModal,
            teamId,
            getTeam,
            isTeamUnset,
        } = this.props;
        const { lessonId, ...restSearchParams } = qs.parse(location.search);

        if (lessonId && courseId) {
            getClessonWithResultsRequest({
                courseId: courseId,
                clessonId: lessonId,
                onSuccess: this.toggleLessonModal,
            });
            history.replace({
                search: qs.stringify(restSearchParams, { arrayFormat: 'bracket' }),
            });
        } else {
            // прячем модалку при переходе с других роутов, чтобы она не пыталась всплыть
            // TODO: решить с менеджерами, может пусть модалка всегда висит
            toggleLessonModal(false);
        }

        this.loadLessonsCountForCourses();
        this.loadDiagnostic();

        setTimeout(() => sendLessonYaMetrika(me, params), 0);

        if (courseId) {
            getCourseStatsRequest(courseId);
        }

        if (getTeam && isTeamUnset) {
            getTeam(teamId);
        }
    }

    componentDidUpdate(prevProps: CourseViewProps) {
        const { courseId, getCourseStatsRequest, history, getClessonWithResultsRequest, location } = this.props;
        const { courseId: prevCourseId, location: prevLocation } = prevProps;

        // если поменялись курсы и по ним не загружено количество уроков - подгружаем количество уроков
        this.loadLessonsCountForCourses();
        // обновляем баннер на случай, если выдали/удалили диагностический урок
        this.loadDiagnostic();

        if (courseId && prevCourseId !== courseId) {
            getCourseStatsRequest(courseId);
        }

        if (location.search !== prevLocation.search) {
            const { lessonId, ...restSearchParams } = qs.parse(location.search);

            if (lessonId && courseId) {
                getClessonWithResultsRequest({
                    courseId: courseId,
                    clessonId: lessonId,
                    onSuccess: this.toggleLessonModal,
                });
                history.replace({
                    search: qs.stringify(restSearchParams, { arrayFormat: 'bracket' }),
                });
            }
        }
    }
    context!: React.ContextType<typeof contextTypes>;

    toggleLessonModal = () => {
        const { toggleLessonModal } = this.props;

        toggleLessonModal(true);
    };

    loadLessonsCountForCourses = () => {
        const { courses, getLessonsCountRequest, allLessonsCounts } = this.props;

        if (!courses) {
            return;
        }

        courses.forEach((course) => {
            if (isEmpty(allLessonsCounts[course.id])) {
                getLessonsCountRequest({ courseId: course.id });
            }
        });
    };

    loadDiagnostic = () => {
        const {
            shouldLoadDiagnostic,
            courseId,
            grade,
            shouldShowSkillStats,
            match: {
                params: { subject },
            },
            getDiagnosticRequest,
            teamId,
        } = this.props;

        if (!shouldShowSkillStats || !courseId || !grade) {
            return;
        }

        if (shouldLoadDiagnostic) {
            const date = new Date().toISOString().split('T')[0];
            getDiagnosticRequest({ courseId, date, grade, subject, teamId });
        }
    };

    handleSelectCourse = (subject: string) => {
        const {
            getRouterPath,
            history,
            match: { path },
        } = this.props;

        history.push(getRouterPath(path, { subject }));
    };

    getCounters = (): Record<'complete' | 'active' | 'drafts', number | undefined> => {
        const { lessonsCounts } = this.props;
        return getFormattedLessonsCount(lessonsCounts);
    };

    renderTabs = (displayMode: COURSE_VIEW_DISPLAY_MODE) => {
        const { teamId, me, screenSize } = this.props;

        const isSmall = screenSize === SCREEN_SIZE.SMALL;
        const shouldShowDisplayModeButton = isSmall && !this.shouldShowAddLessonButton();

        if (!shouldShowDisplayModeButton) {
            return null;
        }

        return (
            <div className="course-view__tabs-wrapper">
                {shouldShowDisplayModeButton && (
                    <CourseViewDisplayModeButton
                        displayMode={displayMode}
                        size={Button.SIZE.L}
                        teacherId={me?.id}
                        teamId={teamId}
                    />
                )}
            </div>
        );
    };

    shouldShowAddLessonButton = () => {
        const { shouldShowSkillStats, courseContainer, canCreateNormalLessonFromBanner, isClosed } = this.props;

        const canAddLessonFromBanner = shouldShowSkillStats && canCreateNormalLessonFromBanner;
        return !isClosed && !courseContainer && !canAddLessonFromBanner;
    };

    // eslint-disable-next-line complexity
    renderListControls = (displayMode: COURSE_VIEW_DISPLAY_MODE) => {
        const { shouldShowSkillStats, me, teamId, screenSize, isClosed } = this.props;
        const shouldShowAddLessonButton = this.shouldShowAddLessonButton();
        const isMedium = screenSize === SCREEN_SIZE.MEDIUM;
        const isSmall = screenSize === SCREEN_SIZE.SMALL;
        const shouldShowDisplayModeButton = !(isClosed || (isSmall && !shouldShowAddLessonButton));

        if (!shouldShowAddLessonButton && !shouldShowDisplayModeButton) {
            return null;
        }

        return (
            <div className="course-view__controls">
                {shouldShowAddLessonButton && (
                    <AddLessonButton
                        textId={isMedium ? 'courseView.createLessonButton.short' : undefined}
                        view={shouldShowSkillStats ? Button.VIEW.SECONDARY : undefined}
                    />
                )}
                {shouldShowDisplayModeButton && (
                    <CourseViewDisplayModeButton
                        displayMode={displayMode}
                        size={isSmall ? Button.SIZE.L : undefined}
                        teacherId={me?.id}
                        teamId={teamId}
                    />
                )}
            </div>
        );
    };

    renderLessonsCalendar = () => {
        const {
            staticUrls,
            getRouterPath,
            match: {
                params: { subject },
            },
        } = this.props;

        if (!isTestplane() && !subject) {
            return <Redirect to={getRouterPath(staticUrls.labSubjectLessonsComplete)} />;
        }

        return (
            <>
                {this.renderTabs(COURSE_VIEW_DISPLAY_MODE.LIST)}
                <CourseCalendar
                    additionalControls={this.renderListControls(COURSE_VIEW_DISPLAY_MODE.LIST)}
                    editorId={subject}
                    mix={'course-view__course-calendar'}
                />
            </>
        );
    };

    // eslint-disable-next-line complexity
    renderLessonsList = () => {
        const {
            staticUrls,
            match: { path },
            getRouterPath,
            localStorage,
            location,
            isClosed,
        } = this.props;

        const searchParams = qs.parse(location.search);

        if (!isTestplane() && !localStorage.get('shouldShowListLessons') && !isClosed) {
            return (
                <Redirect
                    to={`${getRouterPath(staticUrls.labSubjectLessonsCalendar)}?${getPeriodSearchString(
                        getCurrentWeek(),
                        searchParams
                    )}`}
                />
            );
        }

        const lessonsCounters = this.getCounters();
        let currentTab: COURSE_VIEW_LESSONS_TABS;

        switch (path) {
            case staticUrls.labSubjectLessonsComplete:
                currentTab = COURSE_VIEW_LESSONS_TABS.COMPLETE;
                break;
            case staticUrls.labSubjectLessonsActive:
                currentTab = COURSE_VIEW_LESSONS_TABS.ACTIVE;
                break;
            case staticUrls.labSubjectLessonsDrafts:
                currentTab = COURSE_VIEW_LESSONS_TABS.DRAFTS;
                break;
            default:
                currentTab = COURSE_VIEW_LESSONS_TABS.COMPLETE;
                break;
        }

        return (
            <>
                {this.renderTabs(COURSE_VIEW_DISPLAY_MODE.CALENDAR)}
                <div className="course-view__lessons">
                    <div className="course-view__table-head">
                        <CourseViewLessonsTabs
                            currentTab={currentTab}
                            isClosed={isClosed}
                            lessonsCounters={lessonsCounters}
                        />
                        {this.renderListControls(COURSE_VIEW_DISPLAY_MODE.CALENDAR)}
                    </div>
                    {isClosed ? (
                        <Switch>
                            <Route component={CompletedLessons} exact path={staticUrls.labSubjectLessonsComplete} />
                            <Redirect to={getRouterPath(staticUrls.labSubjectLessonsComplete)} />
                        </Switch>
                    ) : (
                        <Switch>
                            <Route component={CompletedLessons} exact path={staticUrls.labSubjectLessonsComplete} />
                            <Route component={ActiveLessonsTab} exact path={staticUrls.labSubjectLessonsActive} />
                            <Route component={Drafts} exact path={staticUrls.labSubjectLessonsDrafts} />
                        </Switch>
                    )}
                </div>
            </>
        );
    };

    // eslint-disable-next-line complexity
    renderContent = () => {
        const { staticUrls } = this.context;
        const {
            shouldShowContent,
            shouldShowEmptyState,
            courseContainer,
            isCourseContainerSuccess,
            isCourseContainerFetchingOrLoading,
            isLessonsCountLoading,
            assignedLessonsCount,
            courseId,
            isClosed,
            shouldShowSkillStats,
            isInBaseCertificateExperiment,
            getRouterPath,
            match: {
                params: { subject },
            },
        } = this.props;

        if (
            !isClosed &&
            (!shouldShowContent ||
                !isCourseContainerSuccess ||
                isLessonsCountLoading ||
                isCourseContainerFetchingOrLoading)
        ) {
            return null;
        }

        if (shouldShowEmptyState) {
            if (courseContainer) {
                return (
                    <div className="course-view__module-empty-state">
                        <CourseContainerLastLessonWidget
                            className="course-view__course-container-banner"
                            subject={subject}
                        />
                        <div className="course-view__module-empty-state-description">
                            <Text
                                id="courseView.emptyState.courseModule.description"
                                size={Text.SIZE.L}
                                type={Text.TYPE.MARKDOWN}
                            />
                        </div>
                    </div>
                );
            }

            if (!shouldShowSkillStats) {
                if (assignedLessonsCount > 0) {
                    return (
                        <>
                            {!isInBaseCertificateExperiment && <CourseViewCertificateBanner />}
                            <EmptyState
                                textId="courseView.emptyState.description.default"
                                unavailableSubjectHeaderId="courseView.emptyState.unavailableSubject.header"
                            />
                        </>
                    );
                }

                return (
                    <EmptyState
                        textId="courseView.emptyState.description.firstLesson"
                        unavailableSubjectHeaderId="courseView.emptyState.unavailableSubject.header"
                    />
                );
            }
        }

        return (
            <div className="course-view__columns">
                <div className="course-view__dashboard">
                    {courseContainer && (
                        <CourseContainerLastLessonWidget
                            className="course-view__course-container-banner"
                            header=""
                            subject={subject}
                        />
                    )}
                    {!isInBaseCertificateExperiment && <CourseViewCertificateBanner />}
                    {shouldShowSkillStats && <OverviewBanner courseId={courseId} />}
                    <Switch>
                        <Redirect
                            exact
                            path={staticUrls.labSubjectLessonsSkillsStats}
                            to={getRouterPath(staticUrls.labSubjectLessonsComplete)}
                        />
                        {isClosed ? (
                            <Redirect
                                exact
                                path={staticUrls.labSubjectLessonsCalendar}
                                to={getRouterPath(staticUrls.labSubjectLessonsComplete)}
                            />
                        ) : (
                            <Route
                                component={this.renderLessonsCalendar}
                                exact
                                path={staticUrls.labSubjectLessonsCalendar}
                            />
                        )}
                        <Route component={this.renderLessonsList} />
                    </Switch>
                </div>
            </div>
        );
    };

    render() {
        const {
            teamId,
            course,
            match: {
                params: { subject },
            },
            location: { search },
            closeLessonModal,
        } = this.props;

        const isMesTeacher = getIsTeacherFromMes(search);
        return (
            <>
                <div className={b('course-view', { free: Boolean(course.free) })}>
                    <BetaBanner className="course-view__beta-banner" section="lessons" />
                    <Header course={course} />
                    <div className="course-view__courses">
                        <SubjectsNav
                            currentSubject={subject}
                            metrikaParams={{ location: 'course_view' }}
                            onSelect={this.handleSelectCourse}
                            teamId={teamId}
                        />
                    </div>
                    {this.renderContent()}
                    <AfishaBannerContainer
                        className="course-view__afisha-banner"
                        metrikaParams={{ from: 'my_lessons' }}
                    />
                </div>
                <LessonView
                    hideBanners={isMesTeacher}
                    hideCloseButton={isMesTeacher}
                    hideFooter={isMesTeacher}
                    isCopyingEnabled={!isMesTeacher}
                    isPutOnBoardEnabled={!isMesTeacher}
                    onClose={closeLessonModal}
                    shouldCloseOnGoBack={true}
                />
                <CustomLessonInfoModal />
                <ClosingLessonModal />
                <CopyLessonModal />
                <SubscriptionModal />
                <TeacherCertificateModal />
            </>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: HOCProps): StateProps => {
    const {
        match: { params },
    } = ownProps;
    const { classId: classIdFromMatch, subject } = params || {};
    const classId = Number(classIdFromMatch);
    const me = getMe(storeState);
    const courses = courseSelectors.getCoursesByClassAndSubject(storeState, { classId, subject });
    const isClosed = courses.every((c) => c.closed);
    // специальный костыль для КМ-ов, чтобы они могди заходить в любые курсы по get-параметру
    const currentCourseId = me ? getCurrentYearOrSearchStringCourseId(me, courses) : null;
    const grade = getCurrentTeamLevel(storeState, { classId: classIdFromMatch });

    return {
        grade,
        shouldLoadDiagnostic: diagnosticsSelectors.shouldLoadDiagnostic(storeState, { subject }),
        allLessonsCounts: courseSelectors.getAllLessonsCounts(storeState, { classId, subject }),
        teamId: classId,
        course: courseSelectors.getCourseByClassAndId(storeState, { classId, courseId: currentCourseId }) || courses[0],
        courses,
        isClosed,
        courseId: currentCourseId,
        currentClass: getCurrentClass(storeState, { classId }),
        lessonsCounts: courseSelectors.getLessonsCounts(storeState, { courseId: currentCourseId }) as LessonsCount,
        me,
        assignedLessonsCount: getAssignedLessonsCount(storeState),
        shouldShowContent: getShouldShowContent(storeState, { classId, courseId: currentCourseId, subject }),
        shouldShowEmptyState: getShouldShowEmptyState(storeState, { classId, subject }),
        isLessonsCountLoading: getIsLessonsCountLoading(storeState, { courseId: currentCourseId }),
        // @ts-ignore Кажется не умеет выводить тайпинг для вложенных параметризованных селекторов
        // (не видит необходимость courseId
        shouldShowSkillStats: getShouldShowSkillStats(storeState, { classId, courseId: currentCourseId }),
        isInBaseCertificateExperiment: getIsInBaseCertificateExperiment(storeState),
        canCreateNormalLessonFromBanner: getCanCreateNormalLessonFromBanner(storeState, {
            courseId: currentCourseId,
            subject,
        }),
        isTeamUnset: classesSelectors.getShouldLoadTeamData(storeState, { classId }),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>): DispatchProps => {
    const { closeLessonModal } = actions;
    const { getLessonsCountRequest } = coursesActions;
    const { getTeam } = classActions;

    return bindActionCreators(
        {
            getDiagnosticRequest: diagnosticsActions.getDiagnosticRequest,
            getLessonsCountRequest,
            getClessonWithResultsRequest: lessonActions.getClessonWithResultsRequest,
            toggleLessonModal: lessonViewActions.toggleModal,
            closeLessonModal,
            getCourseStatsRequest: courseStatsActions.getCourseStatsRequest,
            getTeam,
        },
        dispatch
    );
};

const WrappedComponent: React.ComponentType = mediaQueryResolver(
    [],
    BREAKPOINTS,
    SCREEN_QUERY
)(withRouterPath(withLocalStorage(connect(mapStateToProps, mapDispatchToProps)(withCourseContainer(CourseView)))));

WrappedComponent.displayName = 'CourseView';

export default WrappedComponent;
